import styled, { createGlobalStyle } from "styled-components"

import { ButtonNew } from "components/form/ButtonNew"
import Table from "components/table/Table"

export const ExportButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    path {
      stroke: currentColor;
    }
  }
`

export const FooterButtonsWrapper = styled.div`
  display: flex;
  gap: 12px;
  flex: 1 0 100%;

  button {
    flex: 1;
  }
`

export const StyledButton = styled(ButtonNew)`
  flex: 1;
`

export const ModalContent = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  max-height: calc(90vh - 100px);
`

export const TableWrapper = styled.div`
  overflow-y: auto;
  flex: 1;
  max-height: calc(90vh - 200px);
`

export const StyledTable = styled(Table)`
  min-height: auto;
  overflow: visible;

  > div > div:first-child {
    position: sticky;
    top: 0;
  }
`

export const IconWrapper = styled.div`
  display: flex;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;

  svg {
    width: 22px;
    height: 22px;
  }
`

export const ReordersModalStyle = createGlobalStyle`
  .reorders-modal {
    min-height: 85vh;
    display: flex;
    flex-direction: column;
  }

  .reorders-modal-footer {
    margin-top: auto;
  }
`
